<script>
// import Constants from '../constants';
import { saveAs } from "file-saver";

import simpleLoading from '@/components/simpleLoading';

import {imagesLoad} from '@/util/assetLoadUtil';
import pauseImg from '@/assets/img/soundPlayer/pause.svg';
import playImg from '@/assets/img/soundPlayer/play.svg';
import saveImg from '@/assets/img/soundPlayer/save.svg';
import stopImg from '@/assets/img/soundPlayer/stop.svg';
import volumeImg from '@/assets/img/soundPlayer/volume.svg';

export default {
  name: 'soundPlayer',
  components: {
    simpleLoading,
    imagesLoad,
  },
  props: {
    folder: {
      type: String | Number,
      required: true,
    },
    fileName: {
      type: String,
      required: true,
    },
    fileNameSave: {
      type: String,
      required: true,
    },
    isLong: {
      type: Boolean,
      default: false,
    },
    youtube: {
      type: String,
      default: '',
    },
    niconico: {
      type: String,
      default: '',
    },
    extended: {
      type: String,
      default: 'mp3',
    },
  },
  data() {
    return {
      ready: false,
      sound: {},
      isStop: true,
      isPlay: false,
      isShowVolume: false,
      volume: 50,
      currentTime: '',
    };
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    this.stop();
  },
  methods: {
    async init() {
      this.soundReq = await require(`../assets/sound/${this.folder}/${this.fileName}.mp3`);
      this.sound = new Audio(this.soundReq);
      this.sound.load();
      this.sound.volume = 0.5;
      this.volume = 50;
      
      this.sound.oncanplay = () => { // 再生可能になった
        this.ready = true;
        this.sound.addEventListener('ended', () => { // 最後まで再生
          this.stop();
        });
      }

      await imagesLoad([
        pauseImg,
        playImg,
        saveImg,
        stopImg,
        volumeImg,
      ]);
    },
    play() {
      this.sound.play();
      this.isStop = false;
      this.isPlay = true;
      this.getCurrentTime();
      this.isShowVolume = false;
      // document.body.appendChild(this.sound);
    },
    pause() {
      this.sound.pause();
      this.isStop = false;
      this.isPlay = false;
      this.isShowVolume = false;
    },
    stop() {
      this.sound.pause();
      this.sound.currentTime = 0;
      this.isStop = true;
      this.isPlay = false;
      this.isShowVolume = false;
    },
    save() {
      saveAs(this.soundReq, `${this.fileNameSave}_Demo.${this.extended}`);
      this.isShowVolume = false;
    },
    onSeek() {
      this.currentTime = this.sound.currentTime;
    },
    showVolume() {
      this.isShowVolume = !this.isShowVolume;
    },
    changeVolum() {
      this.volume = Math.floor(this.sound.volume * 100);
    },
    getCurrentTime() {
      this.currentTime = this.sound.currentTime;
      if (this.isPlay) {
        setTimeout(()=> {
          this.getCurrentTime();
        }, 200);
      }
    },
    getShowTime(time) {
      time = Math.floor(time);
      return `${Math.floor(time / 60)}:${( '00' + (time % 60) ).slice( -2 )}`;
    },
  }
};
</script>

<template>
  <div class="sound-player" :class="[isLong ? 'isLong' : '', isPlay ? 'isPlay' : '', $mq]">
    <div class="sound-player-ready" v-if="ready">
      <!-- 再生中アニメーション -->
      <div class="is-play-anime" 
        :class="(isPlay) ? 'is-show' : 'is-hidden'"
      >
        <div class="bar1"></div>
        <div class="bar2"></div>
        <div class="bar3"></div>
      </div>
      <!-- 操作UI -->
      <div class="play btn"
        @click="play"
        :title="$t('message.soundPlayer.play')"
        :class="(!isPlay) ? 'is-show' : 'is-hidden'"
      ></div>
      <div class="pause btn"
        @click="pause"
        :title="$t('message.soundPlayer.pause')"
        :class="(!isStop && isPlay) ? 'is-show' : 'is-hidden'"
      ></div>
      <div class="stop btn"
        @click="stop"
        :title="$t('message.soundPlayer.stop')"
        :class="(!isStop) ? 'is-show' : 'is-hidden'"
      ></div>
      <div
        class="save btn"
        @click="save"
        :title="$t('message.soundPlayer.save')"
      ></div>

      <!-- Youtube -->
      <a class="youtube btn" :title="$t('message.snsName.youTube')" target="_blank"
        v-if="youtube !== ''"
        :href="`https://www.youtube.com/watch?v=${youtube}`"
      ></a>

      <!-- Niconico -->
      <a class="niconico btn" :title="$t('message.snsName.niconico')" target="_blank"
        v-if="niconico !== ''"
        :href="`https://www.nicovideo.jp/watch/${niconico}`"
      ></a>

      <!-- シークバー -->
      <div class="time">
        <div class="currentTime"
          :class="($mq !== 'viewLg' || isLong || !isStop) ? 'is-show' : 'is-hidden'"
        >
          {{getShowTime(currentTime)}}
        </div>
        <div class="seek"
          :title="$t('message.soundPlayer.seek')"
          :class="($mq !== 'viewLg' || isLong || !isStop) ? 'is-show' : 'is-hidden'"
        >
          <input type="range" :max="sound.duration" min="0" step="1" v-model="sound.currentTime" @input="onSeek"/>
        </div>

        <div class="duration">{{getShowTime(sound.duration)}}</div>
      </div>

      <!--音量-->
      <div class="volume"
        :title="$t('message.soundPlayer.volume')"
        :class="(isShowVolume) ? 'is-show-vol' : 'is-hidden-vol'"
      >
        <div class="volume btn" @click="showVolume"></div>
        <input type="range"
          max="1" min="0" step="0.01"
          v-model="sound.volume"
          @input="changeVolum"
        />
        <span class="vol">{{volume}}</span>
      </div>
    </div>

    <div class="sound-player-loading" v-if="!ready">
      <simple-loading/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  @mixin playerHover {
    transition: 0.1s ease-out;
    filter: brightness(1) invert(0);
    &:hover {
      transform: scale(1.1);
      filter: brightness(0) invert(1);
    }
  }
  .sound-player {
    margin: auto;
    background: $textColorA50;
    border-radius: 15px;
    font-size: 0.7em;
    transition: 0.2s ease-out;
    overflow: hidden;
    min-width: 100px;
    .sound-player-ready {
      display: flex;
      align-items: center;
    }
    .btn {
      width: 20px;
      height: 20px;
      margin: 5px;
      display: block;
      cursor: pointer;
      @include bgCenter;
      &.play { background-image: url(../assets/img/soundPlayer/play.svg); }
      &.pause { background-image: url(../assets/img/soundPlayer/pause.svg); }
      &.stop { background-image: url(../assets/img/soundPlayer/stop.svg); }
      &.save { background-image: url(../assets/img/soundPlayer/save.svg); }
      &.youtube {background-image: url(../assets/img/sns/youTube.svg);}
      &.niconico {background-image: url(../assets/img/sns/niconico.svg);}
      &.volume { background-image: url(../assets/img/soundPlayer/volume.svg); }
      @include playerHover;
    }
    .time {
      display: flex;
      .seek {
        display: flex;
        align-items: center;
      }
    }
    .volume {
      display: flex;
      align-items: center;

      width: 30px;
      input, .vol {display: none;}
      &.is-show-vol {
        width: 75px;
        input, .vol {display: block;}
        .btn { display: none; }
      }
    }

    &.isPlay {
      background: $accentColor2A50;
    }

    &.isLong {
      width: 400px;
      .time {
        .seek {
          input[type=range] {
            width:80px;
          }
        }
      }
      .volume {
        width: 110px;
        .btn {
          width: 20px;
        }
        input, .vol, .btn {display: block;}
        &.is-show-vol {
          input, .vol, .btn {display: block;}
        }
      }
    }

    // display noneだと一回目の表示時に画像読み込みが行われるため
    .is-hidden {
      opacity: 0!important;
      transform: scale(0)!important;
      width: 0!important;
      margin: 0!important;
      padding: 0!important;
    }
    .is-show {
    }

    // range--------------------------------------------
    input[type=range] {
      cursor: pointer;
      -webkit-appearance:none;
      appearance: none;
      background: $textColorA50;
      height:5px;
      width:50px;
      border-radius:8px;
      &:focus,
      &:active {
        outline: none;
      }
    }
    input[type=range]::-webkit-slider-thumb{
      -webkit-appearance:none;
      appearance: none;
      background: $bgColor;
      height:15px;
      width:15px;
      border-radius:50%;
      @include playerHover;
    }
    input[type=range]::-ms-tooltip{
      display:none;
    }
    input[type=range]::-moz-range-track{
      height:0;
    }
    input[type=range]::-moz-range-thumb{
      background: $bgColor;
      height:5px;
      width:5px;
      border:none;
      border-radius:50%;
      @include playerHover;
    }
    // isPlayAnime ----------------------------------------------
    .is-play-anime {
      position: relative;
      width: 20px;
      height: 20px;
      margin: 5px;
      .bar1, .bar2, .bar3 {
        position: absolute;
        bottom: 0;
        width: 5px;
        height: 10px;
        background: $textColorA50;
        border-radius: 5px 5px 0 0;
      }
      .bar1 {
        left: 0;
        animation: animeBar1 2s ease 0s infinite;
      }
      .bar2 {
        left: 7.5px;
        animation: animeBar2 2s ease 0s infinite;
      }
      .bar3 {
        right: 0;
        animation: animeBar3 2s ease 0s infinite;
      }
    }
    @keyframes animeBar1 {
      @for $i from 0 through 10 {
        #{$i * 10}% {height: random(20) + px;}
      }
    }

    @keyframes animeBar2 {
      @for $i from 0 through 10 {
        #{$i * 10}% {height: random(20) + px;}
      }
    }

    @keyframes animeBar3 {
      @for $i from 0 through 10 {
        #{$i * 10}% {height: random(20) + px;}
      }
    }

    // loading ---------------------------------------------------

    .sound-player-loading {
      width: 100%;
      height: 100%;
      min-height: 30px;
      position: relative;
    }

    // responsible -----------------------------------------------
    &.viewLg {
      height: 30px;
    }
    &.viewMd {
      min-height: 30px;
      height: auto;
      .time {
        .seek {
          input[type=range] {
            width:80px;
          }
        }
      }
      .volume {
        width: 110px;
        .btn {
          width: 20px;
        }
        input, .vol, .btn {display: block;}
        &.is-show-vol {
          input, .vol, .btn {display: block;}
        }
      }
    }
    &.viewSm {
      min-height: 30px;
      height: auto;
      justify-content: space-around;
      flex-wrap: wrap;
      .sound-player-ready {
        flex-wrap: wrap;
      }
      &.isLong { width: 100%; }
      .time {
        .seek {
          input[type=range] {
            width:80px;
          }
        }
      }
      .volume {
        width: 110px;
        .btn {
          width: 20px;
        }
        input, .vol, .btn {display: block;}
        &.is-show-vol {
          input, .vol, .btn {display: block;}
        }
      }

    }
  }
</style>
